var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M242.667,0 L242.667,242.667 L0,242.667 L0,0 L242.667,0 Z M193,170 L43,170 L43,194 L193,194 L193,170 Z M135.228516,51.2960126 L103.771484,51.2960126 L103.753045,114.228516 L72.2960126,114.228516 L119.5,161.432504 L166.703987,114.228516 L135.246955,114.228516 L135.228516,51.2960126 Z"}));
}

Download.defaultProps = {"width":"40","height":"40","viewBox":"0 0 243 243"};

module.exports = Download;

Download.default = Download;
